














































import { Component } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ColumnApi,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { fetchEstructuraComercial } from './fetchEstructuraComercial';
import EstructuraComercialModal from './EstructuraComercialModal.vue';

@Component({
  components: { MantenedorGridSinCodigo, EstructuraComercialModal },
})
export default class EstructuraComercial extends ComponenteBase {
  accionesTotales: PermisoAccion[];
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.EstructuraComercialCom;

  // Store
  leadershipSearch: string = '';
  showModal: boolean = false;
  currentLeadership: any = {};
  titleModal: string = '';
  typeModal: string = '';
  localeText: any = {};
  gridApi: GridApi;
  columnApi: ColumnApi;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'id',
        field: 'id',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        hide: true,
      },
      {
        headerName: 'Jefatura',
        field: 'nombre',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Cantidad de Ejecutivos',
        field: 'total_ejecutivos',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Ejecutivos',
        field: 'ejecutivos',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Lider',
        field: 'usuariolider',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
      {
        headerName: 'Usuario Creador',
        field: 'usuariocreador',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Fecha Creación',
        field: 'fechacreacion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
      },
      {
        headerName: 'Usuario Modificador',
        field: 'usuariomodificador',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
        hide: true,
      },
      {
        headerName: 'Fecha Modificación',
        field: 'fechamodificacion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 135,
        hide: true,
      },
    ],
    rowSelection: 'multiple',
    pagination: true,
    paginationPageSize: 50, //Solución Paginación
    cacheBlockSize: 10000, //Solución Paginación //Ordenamiento + Seleccion
    paginationAutoPageSize: false,
    onGridSizeChanged: event => {
      event.api.sizeColumnsToFit();
    },
    suppressRowClickSelection: true,
    suppressCellSelection: false,
    localeText: this.localeText,
    onGridReady: this.onGridReady,
    suppressCopyRowsToClipboard: true,
    //onSelectionChanged: this.onSelectionChanged,
    //onRowSelected: this.onSelectionRow,
    //onCellClicked: this.onSelectionRow,
    // onCellMouseOver: this.mouseOverEvent,
    // onCellMouseOut: this.mouseOverOut,
    isExternalFilterPresent: () => {
      return true;
    },
    doesExternalFilterPass: () => {
      return true;
    },
    overlayNoRowsTemplate: 'No hay filas para mostrar',
    blockLoadDebounceMillis: 350,
    //onDragStopped: this.onDragStoppedEvent,
    //onColumnPinned: this.onColumnPinnedEvent,
    columnTypes: {},
    suppressCsvExport: false,
    suppressExcelExport: true,
  };

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    //this.gridApi.setDomLayout('autoHeight');
  }

  async mounted() {
    this.getLeaderShips();
  }

  handleSearchLeadership() {
    this.gridApi.setQuickFilter(this.leadershipSearch);
  }

  async getLeaderShips() {
    this.loadingService.showLoading();
    fetchEstructuraComercial({}, 'getLeaderShips')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.gridApi.setRowData(response.data.data);
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al obtener las jefaturas', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditClick);
  }

  handleEditClick(params: ICellRendererParams) {
    this.typeModal = 'edit';
    this.titleModal = 'Editar Jefatura';
    this.currentLeadership = params.data;
    this.showModal = true;
  }
  handleCreateClick() {
    this.typeModal = 'create';
    this.titleModal = 'Crear Jefatura';
    this.currentLeadership = {};
    this.showModal = true;
  }
  handleCloseCreateModal() {
    this.showModal = false;
    this.getLeaderShips();
  }
}
